var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTabsValidationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5777 15.7504C19.1474 16.7502 18.4323 18 17.2945 18H2.48316C1.34314 18 0.631336 16.7483 1.19991 15.7504L8.60566 2.74954C9.17562 1.74924 10.6032 1.75107 11.1722 2.74954L18.5777 15.7504ZM8.63338 6.47088L8.85289 11.9658C8.86315 12.2229 9.01886 12.4242 9.20746 12.4242H10.6441C10.8327 12.4242 10.9884 12.2229 10.9986 11.9658L11.2182 6.47088C11.2293 6.19314 11.0673 5.95959 10.8636 5.95959H8.98791C8.7842 5.95959 8.62228 6.19314 8.63338 6.47088ZM9.92574 13.5555C9.21167 13.5555 8.63281 14.14 8.63281 14.8609C8.63281 15.5818 9.21167 16.1663 9.92574 16.1663C10.6398 16.1663 11.2187 15.5818 11.2187 14.8609C11.2187 14.14 10.6398 13.5555 9.92574 13.5555Z",
    fill: "#213D58"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsValidationError);
export default __webpack_public_path__ + "static/media/tabs-validation-error.4f54072b.svg";
export { ForwardRef as ReactComponent };